function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Tooltip, useGlobalContext } from 'seagull';
import { SyncLiner24 } from 'seagull/icons';
import compact from 'lodash/compact';
import { FullPageModalHeaderStart, Typography, Badge, TableList, ConfirmationModal, Callout, Button, useIsMounted } from 'seagull';
import { emptyCell, routes } from "../../constants";
import { useEventReporter, useIoContext, useStore, useStoreActions } from "../../contexts";
import { handlePromise, handleRequest } from "../../infra/utils";
import { selectors } from "../../store/state-selectors";
import { InvoiceQboIntegrationStatus } from "../InvoiceQboIntegrationStatus";
import { InvoiceOptimisticUpdateType, getFooter, getItemQBOTooltip, onRequestRefundSuccess } from "./FullPageInvoice.utils";
import { FullPageInvoiceCallout, getFullPageInvoiceCallouts, ResolvePaymentCallout } from "./FullPageInvoiceCallout";
import FullPageInvoiceQboSection from "./FullPageInvoiceQboSection";
import { getStatusLabel } from "../../business-logic/invoiceLogic";
import { invoiceModel, relationshipModel, timeModel } from "../../models";
import FullPageInvoiceAdditionalActions from "./FullPageInvoiceAdditionalActions";
import StopPaymentModal from "./StopPaymentModal";
import { Intent } from "../../infra/access-control";
import RequestRefund from "./RequestRefund";
import { InvoiceDisplayStatus } from 'anchor-scout/types';
import { useOnMount } from "../../hooks/useOnMount";
import { makeManualApprovalMethodNoticePeriod } from "../../models/approval-method-notice-period";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import styles from "./FullPageInvoice.module.scss";
const POLLING_TIMEOUT = 2 * 60 * 1000; // 2min in ms

const approvePaymentLoader = 'approve-payment';
const retryChargeLoader = 'retry-charge';
const payNowLoader = 'pay-now';
const stopPaymentLoader = 'stopPayment';
const resumePaymentLoader = 'resumePayment';
const columnDefs = [{
  width: [180, 400]
},
// Description
{
  width: [30, 30]
},
// Sync Icon
{
  width: [50, 60],
  hAlign: 'end'
},
// Quantity
{
  width: [112, 120],
  hAlign: 'end'
},
// Rate
{
  width: [80, 90],
  hAlign: 'end'
},
// Discount
{
  width: [88, 104],
  hAlign: 'end'
} // Total
];
const headerItems = [{
  value: 'Description'
}, {
  value: ''
}, {
  value: 'Quantity'
}, {
  value: 'Rate'
}, {
  value: 'Discount'
}, {
  value: 'Total'
}];
function getBadgeSkin(status) {
  switch (status) {
    case InvoiceDisplayStatus.Issued:
    case InvoiceDisplayStatus.Voided:
      return 'default';
    case InvoiceDisplayStatus.PaymentInitiated:
    case InvoiceDisplayStatus.Paid:
      return 'success';
    case InvoiceDisplayStatus.Overdue:
    case InvoiceDisplayStatus.PaymentDisputed:
      return 'error';
  }
}
const aCell = (contents, testid) => ({
  value: /*#__PURE__*/React.createElement(Typography, {
    "data-testid": testid
  }, contents)
});
export default function FullPageInvoiceWithData(props) {
  const {
    relationship,
    isVendor,
    integratedInvoice,
    showQboIntegration,
    showInvoiceQboSection,
    refresh,
    onRefresh,
    onRedirectToPaymentMethods,
    onRequestPaymentMethod
  } = props;
  const globalContext = useGlobalContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const history = useHistory();
  const {
    reportButtonClick
  } = useEventReporter();
  const {
    getNow
  } = useIoContext();
  const now = getNow();
  const [invoice, setInvoice] = useState(props.invoice);
  const [disablingAutoApprove, setDisablingAutoApprove] = useState(false);
  const isPendingQboIntegrationSetup = useStore(selectors.integration.isPendingQboIntegrationSetup);
  const {
    name,
    postalAddress
  } = relationship.vendor;
  const vendorLogoUrl = relationshipModel.vendorLogoUrl(relationship);
  const {
    addressOne,
    addressTwo,
    city,
    state,
    postalCode
  } = postalAddress;
  const [activeTimer, setActiveTimer] = useState(null);
  const [pollingForQboUpdate, setPollingForQboUpdate] = useState(null);
  const qboPollingInterval = useStore(state => state.appConfig.qboPollingInterval);
  const isMounted = useIsMounted();
  const {
    QBO_CLASSES
  } = useFeatureFlags();
  useOnMount(() => () => {
    if (activeTimer) clearTimeout(activeTimer);
  });
  useEffect(() => {
    setInvoice(props.invoice);
  }, [props.invoice]);
  useEffect(() => {
    scheduleRefresh();
    function scheduleRefresh() {
      setActiveTimer(window.setTimeout(async () => {
        if (isMounted()) {
          setActiveTimer(null);
          const {
            invoice
          } = await refresh();
          if (!invoiceModel.isStableIntegrationStatus(invoice) && pollingForQboUpdate != null && Date.now() - pollingForQboUpdate < POLLING_TIMEOUT) {
            scheduleRefresh();
          }
        }
      }, qboPollingInterval));
    }
  }, [pollingForQboUpdate]);
  async function reloadInvoice() {
    setPollingForQboUpdate(Date.now());
    refresh().then(() => onRefresh({}));
  }
  const onDisableAutoApprove = async invoice => {
    setDisablingAutoApprove(true);
    try {
      await api.invoice.disableAutoApprove(invoiceModel.id(invoice));
      globalContext.showSuccessToast('Disabled auto-approval', 'disable-auto-approval-success');
      setInvoice(_objectSpread(_objectSpread({}, invoice), {}, {
        approvalMethod: makeManualApprovalMethodNoticePeriod()
      }));
    } catch (_unused) {
      globalContext.showErrorToast('Failed to disable auto-approval', 'disable-auto-approval-error');
    } finally {
      setDisablingAutoApprove(false);
    }
  };
  function onRetryCharge() {
    globalContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          skin: "danger",
          title: "Retry charge of failed payment",
          textAlignCenter: false,
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "You may charge again once. It is recommended to inform your client before you proceed. This will allow your client to verify funds are available."), /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to charge invoice #", invoice.formattedNumber, " now?")),
          onPrimaryButtonClick: async () => {
            globalContext.startLoader(retryChargeLoader);
            const {
              success
            } = await handleRequest(api.invoice.retryCharge(invoice.id));
            if (!success) {
              globalContext.showErrorToast('Unable to retry, please try again', 'retry-charge-error');
              globalContext.stopLoader(retryChargeLoader);
              return;
            }
            await handleRequest(reloadInvoice());
            globalContext.stopLoader(retryChargeLoader);
            dismissModal();
          },
          onSecondaryButtonClick: () => dismissModal(),
          onCloseButtonClick: () => dismissModal(),
          "data-testid": "retry-charge-confirmation-modal",
          primaryButtonLabel: "Charge invoice #".concat(invoice.formattedNumber),
          primaryButtonIntent: Intent.InvoiceRetryCharge,
          secondaryButtonLabel: "Cancel"
        });
      }
    });
  }
  async function onApprovePayment() {
    logBI(10564, {
      invoiceId: invoice.id
    });
    reportButtonClick('billing-hub-client-approved-payment');
    globalContext.startLoader(approvePaymentLoader);
    const {
      success
    } = await handleRequest(api.invoice.approve(invoice.id));
    if (!success) {
      globalContext.showErrorToast("Failed to approve invoice ".concat(invoice.formattedNumber), 'approve-payment-error');
      globalContext.stopLoader(approvePaymentLoader);
      return;
    }
    await handleRequest(reloadInvoice());
    globalContext.stopLoader(approvePaymentLoader);
  }
  async function onPayNow() {
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          textAlignCenter: false,
          onPrimaryButtonClick: async () => {
            logBI(10561, {
              invoiceId: invoice.id
            });
            globalContext.startLoader(payNowLoader);
            const {
              success
            } = await handlePromise(api.invoice.payNow(invoice.id));
            if (!success) {
              globalContext.showErrorToast('Unable to pay now, please try again', 'pay-now-error');
              globalContext.stopLoader(payNowLoader);
              return;
            }
            await handleRequest(reloadInvoice());
            globalContext.stopLoader(payNowLoader);
            dismissModal();
          },
          onCloseButtonClick: () => dismissModal(),
          onSecondaryButtonClick: () => dismissModal(),
          title: "Pay this invoice now?",
          content: /*#__PURE__*/React.createElement(Typography, null, "If you pay this invoice now, we will process the payment immediately. The due date will change to today's date, ", timeModel.formatDate(now.getTime()), ".", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "If you prefer payment on the original due date ", invoiceModel.dueDate(invoice), ", click \"Cancel\"."),
          primaryButtonLabel: "I agree",
          primaryButtonTestid: "invoice-pay-now-confirm",
          secondaryButtonLabel: "Cancel"
        });
      }
    });
  }
  function onStopPayment() {
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: props => /*#__PURE__*/React.createElement(StopPaymentModal, _extends({}, props, {
        formattedNumber: invoice.formattedNumber,
        onSubmit: async reason => {
          const logStopPaymentBI = success => logBI(10562, {
            invoiceId: invoice.id,
            success
          });
          globalContext.startLoader(stopPaymentLoader);
          const {
            success
          } = await handleRequest(api.invoice.stopPayment(invoice.id, reason));
          if (!success) {
            logStopPaymentBI(false);
            globalContext.stopLoader(stopPaymentLoader);
            globalContext.showErrorToast("Failed to stop payment for invoice ".concat(invoice.formattedNumber), 'fpi-stop-payment-error');
            return {
              success: false
            };
          } else {
            logStopPaymentBI(true);
            await handleRequest(reloadInvoice());
            globalContext.stopLoader(stopPaymentLoader);
            return {
              success: true
            };
          }
        }
      }))
    });
  }
  function onResumePayment() {
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref3 => {
        let {
          dismissModal
        } = _ref3;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Resume Payment",
          textAlignCenter: false,
          primaryButtonLabel: "Resume",
          primaryButtonTestid: "submit-resume-payment",
          secondaryButtonLabel: "Back",
          content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "You're about to resume a payment for invoice ", invoice.formattedNumber, "."), /*#__PURE__*/React.createElement(Typography, null, "Any future invoices for this service provider will resume payment collection.")),
          onSecondaryButtonClick: () => dismissModal(),
          onPrimaryButtonClick: async () => {
            const logResumePaymentBI = success => logBI(10563, {
              invoiceId: invoice.id,
              success
            });
            globalContext.startLoader(resumePaymentLoader);
            const {
              success
            } = await handleRequest(api.invoice.resumePayment(invoice.id));
            if (!success) {
              logResumePaymentBI(false);
              globalContext.stopLoader(resumePaymentLoader);
              globalContext.showErrorToast("Failed to resume payment for invoice ".concat(invoice.formattedNumber), 'fpi-resume-payment-error');
            } else {
              logResumePaymentBI(true);
              await handleRequest(reloadInvoice());
              globalContext.stopLoader(resumePaymentLoader);
            }
            dismissModal();
          }
        });
      }
    });
  }
  async function onVoidInvoice() {
    const confirmed = await globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref4 => {
        let {
          dismissModal
        } = _ref4;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Void this invoice",
          "data-testid": "fpi-void-invoice-modal",
          content: "Are you sure you want to void invoice ".concat(invoice.formattedNumber, "?"),
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false),
          primaryButtonLabel: "I'm sure",
          primaryButtonTestid: "fpi-void-invoice-confirm",
          secondaryButtonLabel: "Cancel"
        });
      }
    });
    if (!confirmed) return;
    const loaderName = 'void';
    try {
      globalContext.startLoader(loaderName);
      await api.invoice.void(invoice.id);
    } catch (err) {
      globalContext.showErrorToast("Failed to void invoice ".concat(invoice.formattedNumber), 'fpi-void-invoice-error');
      return;
    } finally {
      globalContext.stopLoader(loaderName);
    }

    // Optimistic update.
    setInvoice(invoiceModel.setVoided(invoice));
    onRefresh({
      optimisticUpdate: {
        type: InvoiceOptimisticUpdateType.Voided,
        invoiceId: invoice.id
      }
    });
  }
  function onRequestRefund() {
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref5 => {
        let {
          dismissModal
        } = _ref5;
        return /*#__PURE__*/React.createElement(RequestRefund, {
          customer: {
            name: relationshipModel.customerName(relationship),
            id: relationshipModel.customer(relationship)
          },
          invoiceID: invoice.id,
          formattedNumber: invoiceModel.formattedNumber(invoice),
          issuedOn: invoiceModel.issuedOn(invoice),
          totalAmount: invoiceModel.totalAmount(invoice),
          dismissModal: dismissModal,
          status: invoiceModel.status(invoice),
          onSuccess: reason => onRequestRefundSuccess({
            invoice,
            sellerId: relationshipModel.sellerID(relationship),
            reason,
            now: getNow(),
            setInvoice,
            onRefresh
          })
        });
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    "data-testid": "fpi-content"
  }, /*#__PURE__*/React.createElement(FullPageModalHeaderStart, null, /*#__PURE__*/React.createElement("div", {
    className: styles.invoiceHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Invoice #", invoice.formattedNumber), /*#__PURE__*/React.createElement(Badge, {
    outlined: true,
    skin: getBadgeSkin(invoice.displayedStatus),
    "data-testid": "fpi-status",
    "data-intent": invoice.displayedStatus
  }, getStatusLabel(invoice.displayedStatus)), showInvoiceQboSection && /*#__PURE__*/React.createElement(InvoiceQboIntegrationStatus, {
    className: styles.qboIcon,
    testid: "fpi-qbo-icon",
    integration: invoiceModel.integration(invoice),
    placement: "right"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.calloutsSection
  }, invoiceModel.isPaymentMethodUnset(invoice) && !relationshipModel.isTerminated(relationship) && /*#__PURE__*/React.createElement(Callout, {
    intent: "warning",
    "data-testid": "fpi-missing-pm",
    withAction: !isVendor ? /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "fpi-add-pm",
      onClick: onRedirectToPaymentMethods
    }, "Add payment method") : /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "fpi-request-pm",
      onClick: onRequestPaymentMethod
    }, "Request payment method")
  }, "For this invoice to get paid through Anchor, a payment method must be connected"), invoiceModel.isPaymentMethodUnverified(invoice) && !relationshipModel.isTerminated(relationship) && /*#__PURE__*/React.createElement(Callout, {
    intent: "warning",
    "data-testid": "fpi-unverified-pm",
    withAction: /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "fpi-verify-pm",
      onClick: onRedirectToPaymentMethods
    }, "Verify payment method")
  }, "The payment method connected to this agreement is not yet verified"), isPendingQboIntegrationSetup && showQboIntegration && /*#__PURE__*/React.createElement(Callout, {
    intent: "warning",
    "data-testid": "fpi-qbo-setup",
    withAction: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "fpi-go-to-qbo-setup",
      skin: "primaryOutline",
      onClick: () => history.push(routes.qboSetup)
    }, "Go to setup")
  }, "Please finish setting up QBO by selecting the accounts in the integration setup page"), showInvoiceQboSection && integratedInvoice && /*#__PURE__*/React.createElement(FullPageInvoiceQboSection, {
    invoice: invoice,
    integratedInvoice: integratedInvoice,
    reloadInvoice: reloadInvoice
  }), getFullPageInvoiceCallouts({
    invoice,
    relationship,
    isVendor,
    disabling: disablingAutoApprove,
    onRetryCharge,
    onApprovePayment,
    onPayNow,
    onResumePayment,
    onDisableAutoApprove
  }).map(props => /*#__PURE__*/React.createElement(FullPageInvoiceCallout, _extends({
    key: props.id
  }, props))), invoiceModel.isPaymentActionRequired(invoice) && /*#__PURE__*/React.createElement(ResolvePaymentCallout, {
    invoice: invoice,
    isVendor: isVendor,
    reloadInvoice: reloadInvoice
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.titleSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, "Invoice"), vendorLogoUrl && /*#__PURE__*/React.createElement("img", {
    className: styles.logo,
    src: vendorLogoUrl
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.titleSection
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.invoiceDetails
  }, [['Client name:', relationship.customer.name], ['Invoice number:', invoiceModel.formattedNumber(invoice)], ['Issue date:', invoiceModel.issuedOn(invoice)], ['Due date:', invoiceModel.dueDate(invoice)]].map((_ref6, idx) => {
    let [label, value] = _ref6;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, /*#__PURE__*/React.createElement(Typography, {
      key: idx + 'l'
    }, label), /*#__PURE__*/React.createElement(Typography, {
      key: idx + 'v'
    }, value));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.vendorDetails
  }, compact([name, addressOne, addressTwo, "".concat(city, ", ").concat(state, ", ").concat(postalCode)]).map((text, idx) => /*#__PURE__*/React.createElement(Typography, {
    key: idx
  }, text)))), /*#__PURE__*/React.createElement(TableList.Provider, {
    variant: "minimal",
    columnDefs: columnDefs
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.table
  }, /*#__PURE__*/React.createElement(TableList.Header, {
    className: styles.tableHeader,
    bgColor: "darkGray",
    items: headerItems
  }), /*#__PURE__*/React.createElement("div", null, invoice.items.map((item, idx) => {
    const getRowTestId = suffix => "fpi-row-".concat(idx, "-").concat(suffix);
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.id
    }, /*#__PURE__*/React.createElement(TableList.Row, {
      size: "small",
      disableMarginBottom: !!item.note,
      items: [aCell(invoiceModel.itemName(item), getRowTestId('name')), QBO_CLASSES && item.qbo ? aCell( /*#__PURE__*/React.createElement(Tooltip, {
        title: /*#__PURE__*/React.createElement("div", {
          "data-testid": getRowTestId('sync-tooltip')
        }, getItemQBOTooltip(item.qbo))
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SyncLiner24, {
        className: styles.syncIcon
      }))), getRowTestId('sync')) : emptyCell, aCell(invoiceModel.itemQuantity(item), getRowTestId('quantity')), aCell(invoiceModel.itemRate(item), getRowTestId('rate')), aCell(invoiceModel.itemDiscount(item), getRowTestId('discount')), aCell(invoiceModel.itemTotalAmount(item), getRowTestId('total'))]
    }), item.note && /*#__PURE__*/React.createElement(TableList.Row, {
      key: item.id + 'note',
      items: [{
        value: /*#__PURE__*/React.createElement(Typography, {
          "data-testid": getRowTestId('note'),
          variant: "paragraph2",
          skin: "secondary"
        }, item.note)
      }, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell]
    }));
  }), /*#__PURE__*/React.createElement(TableList.Row, {
    className: styles.finalRow,
    size: "large",
    items: [emptyCell, emptyCell, emptyCell, emptyCell, aCell('Total'), aCell(invoiceModel.totalAmount(invoice))]
  })))), getFooter(relationship, invoice).map(_ref7 => {
    let {
      id,
      text
    } = _ref7;
    return /*#__PURE__*/React.createElement(Typography, {
      key: id,
      variant: "paragraph2"
    }, text);
  }), /*#__PURE__*/React.createElement(FullPageInvoiceAdditionalActions, {
    invoice: invoice,
    relationship: relationship,
    isVendor: isVendor,
    reloadInvoice: reloadInvoice,
    onVoidInvoice: onVoidInvoice,
    onStopPayment: onStopPayment,
    onResumePayment: onResumePayment,
    onRequestRefund: onRequestRefund
  }));
}